import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLList,
  GraphQLString
} from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  LibraryFilterArg,
  libraryFilterArgType
} from '../types/library-filter-arg'
import { mapLibraryFilters } from '../endpoint-helpers'

export interface SendLibrariesToEmailByFilterMutationArgs {
  readonly input: {
    readonly email: string
    readonly filters: LibraryFilterArg
    readonly organizationID: string
    readonly excludedHashes: string[]
  }
}

const sendLibrariesToEmailByFiltersArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'SendLibrariesToEmailByFilterMutationArg',
      description: 'Mutation input type for sending libraries to email.',
      fields: () => ({
        email: {
          description:
            'The email that the library or libraries will be sent to.',
          type: new GraphQLNonNull(GraphQLString)
        },
        filters: {
          description: 'The filters to be applied to libraries',
          type: new GraphQLNonNull(libraryFilterArgType)
        },
        organizationID: {
          description: 'The ID of the organization of the libraries being sent',
          type: new GraphQLNonNull(GraphQLID)
        },
        excludedHashes: {
          description: 'A list of library hashes to exclude from the filters',
          type: new GraphQLNonNull(new GraphQLList(GraphQLString))
        }
      })
    })
  }
}

export const sendLibrariesToEmailByFilters: GraphQLFieldConfig<
  any,
  Context,
  SendLibrariesToEmailByFilterMutationArgs
> = {
  description: 'Update sensitive data policy',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: sendLibrariesToEmailByFiltersArgs,
  resolve: async (_source, args, context): Promise<GenericMutationResponse> => {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }
    const { organizationID, email, filters, excludedHashes } = args.input
    await context.connector.post(
      `${organizationID}/libraries/share/email/filter?expand=skip_links
    `,
      {
        email,
        ...mapLibraryFilters(filters),
        excludedHashes
      }
    )

    return {
      _placeholder: true
    }
  }
}
